<template>
    <div>
      <v-breadcrumbs
        large
        :items="crumbs"
        divider="/"
        class="pl-0"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-account-multiple</v-icon> <span>Gestão de Tenants</span>
      </h1>
      <v-row>
        <v-col cols="12" md="4">
          <v-switch
            v-model="maintenance"
            label="Ativar modo manutenção"
            color="error"
          />
        </v-col>
        <v-col cols="12" md="2" class="mt-4">
          <v-btn x-small class="success" @click="setStatus">Alterar</v-btn>
        </v-col>
      </v-row>
        <div style="position:relative">
        <v-container>
          <v-speed-dial
            absolute
            v-model="speedDial"
            top
            right
            direction="bottom"
            :open-on-hover="true"
          >
            <template v-slot:activator>
              <v-tooltip right color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    v-model="speedDial"
                    color="primary"
                    dark
                    x-large
                    fab
                  >
                    <v-icon v-if="speedDial">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <span>Opções</span>
              </v-tooltip>
            </template>
            <v-tooltip right color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="info"
                  large
                  @click="searching = true"
                >
                  <v-icon>mdi-filter</v-icon>
                </v-btn>
              </template>
              <span>Pesquisar</span>
            </v-tooltip>
            <v-tooltip right color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="secondary"
                  large
                  to="/tenants/create"
                  v-if="$root.session.hasPermission(['super', 'tenants.create'])"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Registar</span>
            </v-tooltip>
          </v-speed-dial>
        </v-container>

        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :loading="loading"
          :footer-props="tableFooter"
          :options.sync="options"
          class="mt-16 elevation-10"
          locale="pt-pt"
        >
          <template v-slot:item.last_access="{item}">
            {{item.last_accesses.length > 0 ? item.last_accesses[0].name : '-'}}
          </template>
          <template v-slot:item.status="{item}">
            <status-indicator :status="getStatus(item)" />
          </template>

          <template v-slot:item.subscription_end="{item}">
            {{ item.subscription_end }}
            <v-icon color="error" v-if="nearExpiration(item.subscription_end)">
              mdi-bell-alert
            </v-icon>
          </template>

          <template v-slot:item.actions="{item}">
            <IconView
              class="mr-2"
              @click="viewTenant(item)"
            />
            <IconRemove
              v-if="$root.session.hasPermission(['super', 'tenants.delete'])"
              class="mr-2"
              @on-submit="deleteTenant(item)"
            />
          </template>
        </v-data-table>
      </div>
      <v-navigation-drawer
          fixed
          right
          v-model="searching"
          hide-overlay
          width="520"
          class="pt-6"
        >
        <v-list>
          <v-list-item>
            <v-btn fab small color="secondary" @click="searching = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn absolute right small color="error" @click="resetTenant">
              Limpar Campos
            </v-btn>
          </v-list-item>
        </v-list>
        <v-list class="pt-10">
          <v-form @submit.prevent="searchTenant">
            
            <v-list-item>
              <v-text-field
                v-model="filter.name"
                prepend-inner-icon="mdi-account-details"
                label="Código"
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-text-field
                v-model="filter.display_name"
                prepend-inner-icon="mdi-account-details"
                label="Nome"
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-checkbox
                v-model="filter.deleted"
                prepend-inner-icon="mdi-deleted"
                label="Eliminados"
                clearable
              ></v-checkbox>
            </v-list-item>
            <v-row
              class="mt-10"
              align="center"
              justify="space-around"
            >
            <v-btn
              color="primary"
              type="submit"
            >
              Pesquisar
            </v-btn>
            </v-row>
          </v-form>
        </v-list>
      </v-navigation-drawer>
    </div>
</template>
<script>
import IconRemove from '@/components/ui/IconRemove.vue';
import IconView from '@/components/ui/IconView.vue';
import Tenant from "@/api/Tenant.js";
import System from "@/api/System.js";

export default {
  components: {
    IconRemove,
    IconView
  },
  watch: {
    'options': {
      immediate: false,
      handler () {
        setTimeout(() => {this.searchTenant()}, 10);
      },
      deep: true,
    },
  },
  beforeCreate(){
    document.title = "Hefesto - Gestão de Tenants";

  },
  data: () => ({
    maintenance: false,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'status',
      },
      {
        text: 'Nome',
        sortable: false,
        value: 'name',
      },
      {
        text: 'NIF',
        sortable: false,
        value: 'nif',
      },
      {
        text: 'Último acesso',
        sortable: false,
        value: 'last_access',
      },
      {
        text: 'Domínio',
        sortable: false,
        value: 'domain',
      },
      {
        text: 'Início Subscrição',
        sortable: false,
        value: 'subscription_start',
      },
      {
        text: 'Fim Subscrição',
        sortable: false,
        value: 'subscription_end',
      },
      { 
        text: 'Opções', 
        value: 'actions', 
        sortable: false 
      },
    ],
    items: [],
    total: 0,
    loading: false,
    searching: false,
    tableFooter: {
      'items-per-page-options': [5, 10, 15, 20],
      'items-per-page-text': "Linhas por página"
    },
    options: {},
    speedDial:false,
    filter: {
      name: null,
      display_name:null,
      user_id:null,
      deleted: false
    },
    users:[]
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "tenants.read"])) {
      this.$router.push('/admin');
    }

    this.fillBaseData();
  },
  methods:{
    setStatus(){
      let data = {
        maintenance: this.maintenance
      }
      System.setStatus(data).then(()  =>  {
        window.location.reload()
      })
    },
    getStatus(item){
      //item.active ? 'positive' : 'negative'
      let result = 'positive'

      if(item.active == false)
        result = 'negative';

      let today = new Date();
      let sub = new Date(item.subscription_end)

      if(today >= sub)
        result = 'intermediary'

      return result
    },
    nearExpiration(dt){
      const date1 = new Date(dt);
      const date2 = new Date()
      const diffTime = Math.abs(date2 - date1)

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

      if(diffDays <= 30)
        return true

      return false;
    },
    fillBaseData() {

      System.getStatus().then((resp)  =>  {
        this.maintenance = resp.data.value == "0" ? false : true
      })

      if(localStorage["tenants-" + this.$root.session.id] != undefined){

        let data = JSON.parse(localStorage["tenants-" + this.$root.session.id]);

        this.filter = data.filter;

        this.options = data.options;
      }
    },
    searchTenant(event){
      if(!!event && event.type == 'submit'){
        this.options.page = 1;
      }

      this.loading = true;

      let filter = {...this.filter};

      let request = {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        deleted: this.filter.deleted
      };
    
      Object.assign(request, filter);

      localStorage["tenants-" + this.$root.session.id] = JSON.stringify({
        filter: this.filter,
        options: this.options,
      });

      Tenant.search(request).then(response => {
        
        let data = response.data;

        this.total = data.total;

        this.items = data.data.map((item) => {

          this.searching = false;

          return item;
        });

        this.loading = false;

      });
    },
    resetTenant()
    {
      this.filter = {};

      this.searchTenant();
    },
    viewTenant(item){
      this.$router.push('tenants/update/' + item.id);
    },
    deleteTenant(item){
    Tenant.delete(item.id)
        .then(() => {
          this.searchTenant();
        });
    },
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: 'Gestão de tenants',
          disabled: false,
          to: '/tenants',
          exact: true,
        },
      ];
    }
  }
};
</script>
